var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_900, DynamicSvg, Typography, checkIsPlatform, debounce, getTestId, isValidObject } from '@airtel/air-design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { CalloutWidget } from '../callout-widget';
import { getAccordionListWidgetStyles } from './AccordionListWidgetStyles';
import { AccordionComponentWrapper } from './components/accordion-component-wrapper';
import { SearchBar } from './components/search-bar';
export var AccordionListWidgetComponent = props => {
  var id = props.id,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    onUserAction = props.onUserAction,
    _props$showSearchBar = props.showSearchBar,
    showSearchBar = _props$showSearchBar === void 0 ? false : _props$showSearchBar,
    _props$listMultipleDa = props.listMultipleData,
    listMultipleData = _props$listMultipleDa === void 0 ? [] : _props$listMultipleDa,
    _props$showMultipleLi = props.showMultipleListWithHeading,
    showMultipleListWithHeading = _props$showMultipleLi === void 0 ? false : _props$showMultipleLi,
    inputIconName = props.inputIconName,
    placeholderText = props.placeholderText,
    onTextChangeHandler = props.onTextChangeHandler,
    _props$noDataFoundMet = props.noDataFoundMeta,
    noDataFoundMeta = _props$noDataFoundMet === void 0 ? {} : _props$noDataFoundMet,
    _props$debounceTiming = props.debounceTiming,
    debounceTiming = _props$debounceTiming === void 0 ? 300 : _props$debounceTiming,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'AccordionListWidget' : _props$testID,
    _props$initialItemsCo = props.initialItemsCount,
    initialItemsCount = _props$initialItemsCo === void 0 ? 0 : _props$initialItemsCo,
    onViewAllCtaPressMetaData = props.onViewAllCtaPressMetaData,
    sendManualImpression = props.sendManualImpression,
    calloutProps = props.calloutProps,
    restProps = __rest(props, ["id", "data", "onUserAction", "showSearchBar", "listMultipleData", "showMultipleListWithHeading", "inputIconName", "placeholderText", "onTextChangeHandler", "noDataFoundMeta", "debounceTiming", "testID", "initialItemsCount", "onViewAllCtaPressMetaData", "sendManualImpression", "calloutProps"]);
  var accordionListWidgetStyles = getAccordionListWidgetStyles();
  var _noDataFoundMeta$icon = noDataFoundMeta.iconName,
    iconName = _noDataFoundMeta$icon === void 0 ? 'InfoIcon' : _noDataFoundMeta$icon,
    heading = noDataFoundMeta.heading,
    description = noDataFoundMeta.description;
  var _useState = useState(listMultipleData),
    filteredListMultipleData = _useState[0],
    setfilteredListMultipleData = _useState[1];
  var _useState2 = useState(initialItemsCount > 0 ? initialItemsCount : data === null || data === void 0 ? void 0 : data.length),
    itemCount = _useState2[0],
    setItemCount = _useState2[1];
  var _useState3 = useState(Boolean(initialItemsCount)),
    showViewAllCta = _useState3[0],
    setShowViewAllCta = _useState3[1];
  var _useState4 = useState({
      level1: '',
      level2: ''
    }),
    selectedAccordion = _useState4[0],
    setSelectedAccordion = _useState4[1];
  var setOfVisitedIds = useRef(new Set());
  useEffect(() => {
    setfilteredListMultipleData(listMultipleData);
  }, [JSON.stringify(listMultipleData)]);
  useEffect(() => {
    if (sendManualImpression) {
      data === null || data === void 0 ? void 0 : data.forEach((itemData, itemIndex) => {
        var _a;
        (itemData === null || itemData === void 0 ? void 0 : itemData.onItemVisibleMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, itemData === null || itemData === void 0 ? void 0 : itemData.onItemVisibleMetaData), Object.assign({
          index: itemIndex
        }, itemData)));
        (_a = itemData.level2Data) === null || _a === void 0 ? void 0 : _a.forEach((l2itemData, l2Index) => {
          (l2itemData === null || l2itemData === void 0 ? void 0 : l2itemData.onItemVisibleMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, l2itemData === null || l2itemData === void 0 ? void 0 : l2itemData.onItemVisibleMetaData), Object.assign({
            index: l2Index
          }, l2itemData)));
        });
      });
    }
  }, []);
  var collapseAll = (index, isLevel2) => {
    var updateState = (state, key, index) => {
      var _key = key + "_" + index;
      if (key == 'level1') {
        state = {
          [key]: _key
        };
      } else {
        state = Object.assign(Object.assign({}, state), {
          [key]: _key
        });
      }
      return state;
    };
    setSelectedAccordion(prevKey => {
      if (isLevel2) {
        return updateState(prevKey, 'level2', index);
      } else {
        return updateState(prevKey, 'level1', index);
      }
    });
  };
  var onViewAllPressHandler = (data, parentIndex) => {
    setItemCount(data === null || data === void 0 ? void 0 : data.length);
    setShowViewAllCta(false);
    onViewAllCtaPressMetaData && onUserAction(Object.assign({
      id
    }, onViewAllCtaPressMetaData), {
      data,
      index: parentIndex
    });
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      var sendImpression = checkIsPlatform('web') && !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        sendImpression && ((_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index));
        ((_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_l = (_k = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _k === void 0 ? void 0 : _k[i].item) === null || _l === void 0 ? void 0 : _l.onItemImpression), (_m = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _m === void 0 ? void 0 : _m.item));
      }
    }
  }, []);
  var handleTextChange = text => {
    onTextChangeHandler && onUserAction(Object.assign({
      id
    }, onTextChangeHandler), {
      text
    });
  };
  var debouncedHandleTextChange = debounce(handleTextChange, debounceTiming);
  return _jsxs(_Fragment, {
    children: [showSearchBar && _jsx(View, Object.assign({
      style: [accordionListWidgetStyles.accordionListHeading]
    }, {
      children: _jsx(SearchBar, Object.assign({
        placeholderText: placeholderText,
        postIconName: inputIconName,
        onTextChangeHandler: debouncedHandleTextChange
      }, getTestId(testID, 'searchBar')))
    })), !!isValidObject(calloutProps) && _jsx(CalloutWidget, Object.assign({}, calloutProps, {
      style: [accordionListWidgetStyles.calloutStyle, calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.style],
      onUserAction: onUserAction
    }, getTestId(testID + '_calloutwidget'))), showMultipleListWithHeading ? _jsx(_Fragment, {
      children: (filteredListMultipleData === null || filteredListMultipleData === void 0 ? void 0 : filteredListMultipleData.length) == 0 ? _jsxs(View, Object.assign({
        style: [accordionListWidgetStyles.noDataWrapper]
      }, {
        children: [_jsxs(View, Object.assign({
          style: [accordionListWidgetStyles.textWithIcon]
        }, {
          children: [!!iconName && _jsx(DynamicSvg, Object.assign({
            iconName: iconName,
            fontSize: 20,
            style: accordionListWidgetStyles.iconSpacer
          }, getTestId(testID, 'icon'))), _jsx(Typography, Object.assign({
            type: "body-single-line-sm-bold",
            color: BLACK_900,
            text: heading,
            textAlignment: "center"
          }, getTestId(testID, 'heading')))]
        })), _jsx(Typography, Object.assign({
          type: "body-single-line-sm",
          color: BLACK_900,
          text: description,
          textAlignment: "center",
          style: [accordionListWidgetStyles.itemSpacer]
        }, getTestId(testID, 'description')))]
      })) : _jsx(_Fragment, {
        children: filteredListMultipleData === null || filteredListMultipleData === void 0 ? void 0 : filteredListMultipleData.map((list, parentIndex) => {
          return _jsxs(View, Object.assign({
            style: [accordionListWidgetStyles.accordionListWrapper]
          }, {
            children: [_jsx(View, Object.assign({
              style: (list === null || list === void 0 ? void 0 : list.accordionListHeading) && [accordionListWidgetStyles.accordionListHeading]
            }, {
              children: _jsx(Typography, Object.assign({
                type: "body-single-line-lg-bold",
                color: BLACK_900,
                text: list.accordionListHeading
              }, getTestId(testID + '_accordionListHeading', parentIndex.toString())))
            })), _jsx(AccordionComponentWrapper, Object.assign({
              data: list === null || list === void 0 ? void 0 : list.data,
              parentIndex: parentIndex.toString(),
              onViewAllPressHandler: onViewAllPressHandler,
              showViewAllCta: showViewAllCta,
              selectedAccordion: selectedAccordion,
              collapseAll: collapseAll,
              onViewableItemsChanged: onViewableItemsChanged,
              onUserAction: onUserAction,
              initialItemsCount: initialItemsCount,
              itemCount: itemCount,
              testID: testID
            }, restProps))]
          }), "listIndex-" + parentIndex);
        })
      })
    }) : _jsx(_Fragment, {
      children: _jsx(AccordionComponentWrapper, Object.assign({
        data: data,
        onViewAllPressHandler: onViewAllPressHandler,
        showViewAllCta: showViewAllCta,
        selectedAccordion: selectedAccordion,
        collapseAll: collapseAll,
        onViewableItemsChanged: onViewableItemsChanged,
        onUserAction: onUserAction,
        initialItemsCount: initialItemsCount,
        itemCount: itemCount,
        testID: testID
      }, restProps))
    })]
  });
};
AccordionListWidgetComponent.genericRendererKey = 'AirAccordionListWidget';